interface Props extends React.HTMLAttributes<HTMLDivElement> {
  x?: number;
  y?: number;
}

function ShiftBy({ x = 0, y = 0, children }: Props) {
  return (
    <div
      style={{
        transform: `translate(${x}px, ${y}px)`,
      }}
    >
      {children}
    </div>
  );
}

export default ShiftBy;
